// Angular imports
import { Component, NgZone, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import {
	Observable,
	Subject,
	forkJoin,
	lastValueFrom,
	of,
	takeUntil,
} from "rxjs";

// Models
import { ContextLocationViewModel } from "src/app/_core/models/main/context-location.model";
import { LinkItem } from "src/app/_core/models/main/link-item.model";
import { Policies } from "src/app/_core/models/main/policies.enum";
import { getHomeMenu } from "src/app/_core/constants/menu.constants";
import * as L from "leaflet";
import { tileLayer } from "leaflet";

// Services
import { MatTabGroup } from "@angular/material/tabs";
import { TranslateService } from "@ngx-translate/core";
import { CebeContratoViewModel } from "src/app/_core/models/centros/cebe-contract.model";
import { CebePalViewModel } from "src/app/_core/models/centros/cebe-pal.model";
import { CebeViewModel } from "src/app/_core/models/centros/cebe.model";
import { CentroProcedure } from "src/app/_core/models/centros/centro-procedure.model";
import { CebePalService } from "src/app/_core/providers/cebe-pal.service";
import { CebesContractService } from "src/app/_core/providers/cebes-contract.service";
import { CebesService } from "src/app/_core/providers/cebes.service";
import { CentrosService } from "src/app/_core/providers/centros.service";
import {
	GlobalService,
	MigaDePan,
} from "src/app/_core/providers/global.service";
import { ImportService } from "src/app/_core/providers/import.service";
import { NotificationService } from "src/app/_core/providers/notification.service";
import { ContractDetailsCardComponent } from "../../components/cebe-contracts/contracts-details-card/contract-details-card.component";
import { CebePalCardComponent } from "../../components/cebe-pal/cebe-pal-card.component";
import { CebeDetailsCardComponent } from "../../components/cebe/cebe-details-card/cebe-details-card.component";
import { CentrosProcedureViewModel } from "src/app/_core/models/master/centro.model";
import { LoaderService } from "src/app/_core/providers/loader.service";
import { SiteService } from "src/app/_core/providers/site.service";
import { MiniMapComponent } from "../../components/maps/mini-map/mini-map.component";

@Component({
	selector: "app-cebe-page",
	templateUrl: "./cebe.page.html",
	styleUrls: ["./cebe.page.scss"],
})
export class CebePageComponent implements OnInit, OnDestroy {
	// Properties
	@ViewChild("cebeDetailsCardComponentRef")
	cebeDetailsComponent: CebeDetailsCardComponent;
	@ViewChild("contractDetailsCardComponentRef")
	contractDetailsComponent: ContractDetailsCardComponent;
	@ViewChild("cebePalCardComponentRef")
	cebePalComponent: CebePalCardComponent;
	@ViewChild("tabGroup") tabGroup: MatTabGroup;
	@ViewChild("fileInputFinance") fileInput: any;
	@ViewChild(MiniMapComponent) miniMap: MiniMapComponent;
	public cebe: CebeViewModel;
	public contract: CebeContratoViewModel;
	public pal: CebePalViewModel;
	public selectedTabIndex: number;
	private selectedFilesFinance: File | null = null;
	public centros: CentroProcedure[] = [];
	validatedCebeDetailsForm: boolean;
	validatedContractForm: boolean;
	validatedPalForm: boolean;

	// Attributes
	private readonly destroy$ = new Subject<void>();
	public contextLocation: ContextLocationViewModel;

	private readonly menu: LinkItem[] = getHomeMenu();

	// Maps
	public options: any;
	public map: L.Map;
	public layers: any = [];
	public center: L.LatLng;
	public sites: Array<CentrosProcedureViewModel> = [];
	public allSites: Array<CentrosProcedureViewModel>;
	public fitBounds: L.LatLngBounds;
	public markerClusterGroup: any;
	public markerClusterData: any[] = [];
	public markerClusterOptions: any;

	// Filter
	public filterOptions: string[] = [];
	public filterSelection: string[] = [];

	// Selection
	public displayDialog: boolean = false;
	public selectedItem: CentrosProcedureViewModel;
	private readonly currentMarker: L.Marker;

	constructor(
		private readonly _titleService: Title,
		private readonly _translateService: TranslateService,
		private readonly _route: ActivatedRoute,
		private readonly router: Router,
		private readonly _cebesService: CebesService,
		private readonly _cebesContractService: CebesContractService,
		private readonly _centrosService: CentrosService,
		private readonly _importService: ImportService,
		private readonly _globalService: GlobalService,
		private readonly _cebePalService: CebePalService,
		private readonly _notificationService: NotificationService,
		private readonly _zone: NgZone,
		private readonly _router: Router,
		private readonly _loaderService: LoaderService,
		private readonly _siteService: SiteService,
	) {
		/* const cebeId = Number(this._route.snapshot.paramMap.get("cebe"));
		forkJoin({
			cebe: cebeId ? this._cebesService.getCebeById(cebeId) : of(null),
		}).subscribe(({ cebe }) => {
			let miga: MigaDePan = {
				nombre: "(" + cebe?.codigo + ") " + cebe?.descripcion,
				url: window.location.href,
			};
			this._globalService.agregarMigaUnica(miga);
		}); */
	}

	// Events
	ngOnInit(): void {
		this.markerClusterOptions = { maxClusterRadius: 50 };
		/* this._loaderService.start(); */
		this.contextLocation = {
			country: "",
			countryName: "",
			service: "",
			serviceName: "",
			site: "",
			siteName: "",
		};
		this._globalService.setHeaderOptions(
			[],
			this.contextLocation,
			[],
			this.menu,
		);
		this._titleService.setTitle(
			this._translateService.instant("title.cebe.home"),
		);
		this.loadCebeInit();
	}

	public loadCebeInit() {
		this._route.params
			.pipe(takeUntil(this.destroy$))
			.subscribe(async (params) => {
				this.contextLocation = {
					cebe: params["cebe"],
				};
				await this.loadData();
			});
	}

	ngAfterViewInit(): void {
		for (let index = this.tabGroup?._tabs.length; index >= 0; index--) {
			setTimeout(() => {
				this.tabGroup.selectedIndex = index;
			}, 1500);
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	forwardTab() {
		const currentTabIndex = this.tabGroup?.selectedIndex;
		const lastTabIndex = this.tabGroup?._tabs.length - 1;

		if (currentTabIndex !== lastTabIndex) {
			// this.save(currentTabIndex).subscribe((savedSuccess: boolean) => {
			//   if (savedSuccess) {
			this.navigateToNextTab(currentTabIndex);
			//   }
			// });
		} else {
			this.navigateToNextTab(currentTabIndex);
		}
	}

	save(): Observable<boolean> {
		if (this.cebe.edicionCebe) {
			this.cebeDetailsComponent.triggerFormSubmission();
			if (this.cebe?.oferta) {
				this.cebePalComponent.triggerFormSubmission();
			}

			this.contractDetailsComponent.triggerFormSubmission();
		}
		return of(true);
	}

	backTab() {
		const currentTabIndex = this.tabGroup?.selectedIndex;
		const lastTabIndex = this.tabGroup?._tabs.length - 1;

		if (currentTabIndex !== lastTabIndex) {
			// this.save(currentTabIndex).subscribe((savedSuccess: boolean) => {
			// if (savedSuccess) {
			this.navigateToBackTab(currentTabIndex);
			// }
			// });
		} else {
			this.navigateToBackTab(currentTabIndex);
		}
	}

	//   saveonly() {
	//     const currentTabIndex = this.tabGroup?.selectedIndex;
	//     const lastTabIndex = this.tabGroup?._tabs.length - 1;
	//     this.save(currentTabIndex).subscribe((savedSuccess: boolean) => {
	//       if (savedSuccess) {
	//       }
	//     });
	//   }

	private navigateToNextTab(currentTabIndex: number | undefined): void {
		if (
			currentTabIndex !== undefined &&
			currentTabIndex < this.tabGroup?._tabs.length - 1
		) {
			if (currentTabIndex + 1 === this.tabGroup?._tabs.length - 1) {
				if (this.centros.length === 0 && this.cebe?.edicionCebe) {
					this.goToCreateCentro();
				} else {
					this.tabGroup.selectedIndex = currentTabIndex + 1;
				}
			} else {
				this.tabGroup.selectedIndex = currentTabIndex + 1;
			}
		} else {
			this.router.navigate(["/home"]);
		}
	}

	private navigateToBackTab(currentTabIndex: number | undefined): void {
		if (currentTabIndex !== undefined && currentTabIndex == 0) {
			this.router.navigate(["/home"]);
		} else {
			this.tabGroup.selectedIndex = currentTabIndex - 1;
		}
	}

	goToCreateCentro() {
		this.router.navigate(["/centro/create/", this.cebe?.id]);
	}

	goToAdmin() {
		this.router.navigate(["/admin"]);
	}

	onUploadFinanceDataFiles(): void {
		this.fileInput.nativeElement.click();
	}

	onFileFinanceChange(event: any): void {
		const files: FileList = event.target.files;

		if (files && files.length > 0) {
			this.selectedFilesFinance = files.item(0);
			this.uploadFiles();
		}
	}

	uploadFiles(): void {
		if (this.selectedFilesFinance) {
			this._importService
				.uploadFinancialData(this.selectedFilesFinance)
				.subscribe(
					(response: string) => {
						const blob = new Blob([response], {
							type: "text/plain",
						});
						const url = window.URL.createObjectURL(blob);
						const a = document.createElement("a");
						a.href = url;
						a.download = `resultadoCarga_${
							this.selectedFilesFinance.name
						}.txt`;
						document.body.appendChild(a);
						a.click();
						document.body.removeChild(a);
						window.URL.revokeObjectURL(url);
					},
					(error) => {
						console.error("Error uploading financial data:", error);
					},
				);
		}
	}

	async changeOfertaValue(toggleValue: boolean) {
		this.cebe.oferta = toggleValue;
		await this.loadPal(this.cebe.id);
	}

	changeContratoValue(toggleValue: boolean) {
		this.cebe.isContrato = toggleValue;
	}

	async changeCentroValue(toggleValue: boolean) {
		this.cebe.centro = toggleValue;
	}

	cebeDetailsFormStatus(status: boolean) {
		this.validatedCebeDetailsForm = status;
	}

	contractFormStatus(status: boolean) {
		this.validatedContractForm = status;
	}

	palFormStatus(status: boolean) {
		this.validatedPalForm = status;
	}

	// Private methods
	async loadData() {
		await this.loadCebe(this.contextLocation.cebe);
		this.loadCentros(this.contextLocation.cebe);
	}

	async loadCebe(cebeId: number) {
		try {
			const cebe: CebeViewModel = await lastValueFrom(
				this._cebesService.getCebeById(cebeId),
			);
			const miga: MigaDePan = {
				nombre: `(${cebe.codigo}) ${cebe.descripcion}`,
				url: window.location.href,
			};
			this._globalService.agregarCebeToMiga(miga);

			this.cebe = cebe;

			this._cebesService.setCebeId(this.cebe.id);

			this.loadContract(cebeId);

			if (this.cebe.oferta) {
				await this.loadPal(cebeId);
			}
		} catch (error) {
			this._notificationService.showError(error);
		}
	}

	async loadPal(cebeId: number) {
		try {
			const palRes: CebePalViewModel = await lastValueFrom(
				this._cebePalService.getPalByCebe(cebeId),
			);

			if (palRes) {
				this.pal = palRes;
			} else {
				const palAux: CebePalViewModel = {
					cebeID: 0,
					disponeInfo: false,
					fechaAdjudica: null,
					gis: false,
					id: 0,
					ofertaAdjudica: null,
					presupuestoAsignado: null,
					responsableOfertaID: null,
					riesgoSocialID: null,
				};

				this.pal = palAux;
			}
		} catch (error) {
			this._notificationService.showError(error);
		}
	}

	async loadContract(cebeId: number) {
		try {
			const contratoRes: CebeContratoViewModel = await lastValueFrom(
				this._cebesContractService.getContratoByCebe(
					cebeId,
					this.cebe?.actividadID,
					this.cebe?.tipoProyectoID,
				),
			);

			this.contract = contratoRes;
			this.contractDetailsComponent.contract = contratoRes;
		} catch (error) {}
	}

	// private loadContract(cebeId: number): Observable<CebeContratoViewModel> {
	//   return this._cebesContractService
	//     .getContratoByCebe(
	//       cebeId,
	//       this.cebe?.actividadID,
	//       this.cebe?.tipoProyectoID
	//     )
	//     .pipe(
	//       takeUntil(this.destroy$),
	//       tap((contract: CebeContratoViewModel) => {
	//         this.contract = contract;
	//       })
	//     );
	// }

	private loadCentros(cebeId: number) {
		this._centrosService
			.getCentroByCebeId(cebeId)
			.pipe(takeUntil(this.destroy$))
			.subscribe((centros) => {
				this.centros = centros;
			});
	}
}
